/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"NotificationText":"NotificationText_Dsq2E"};